const LOGIN_PATH = "/user/login";

export const hardReload = (pathname) => {
  if (pathname === undefined) {
    globalThis.location.reload();
    return;
  }

  if (pathname !== LOGIN_PATH) {
    throw new Error("Reload destination must be the login path.");
  }

  globalThis.location.replace(`${LOGIN_PATH}?_refresh=${Date.now()}`);
};
